const lbaODataIndexMultiSelect = angular.module('app.lbaODataIndexMultiSelect', []);

lbaODataIndexMultiSelect.controller('lbaODataIndexMultiSelectCtrl', require('./lbaODataIndexMultiSelectCtrl'));
lbaODataIndexMultiSelect.directive('lbaODataIndexMultiSelect', require('./lbaODataIndexMultiSelectDir'));

export default lbaODataIndexMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lbaODataIndexMultiSelect/index.js